// @flow

export type PopupState = {
  openedPopup: string,
}

const PopupStateReducer = (
  state: ?PopupState = null,
  action:
    | { type: "POPUP_STATE_SET", obj: PopupState }
    | { type: "POPUP_STATE_UNSET", popupName: string },
) => {
  switch (action.type) {
    case "POPUP_STATE_SET":
      return action.obj
    case "POPUP_STATE_UNSET":
      if (state && action.popupName === state.openedPopup) {
        return null
      }
      return state

    default:
      return state
  }
}

export default PopupStateReducer

export const setPopupState = (obj: PopupState) => ({
  type: "POPUP_STATE_SET",
  obj,
})

export const unsetPopupState = (popupName: string) => ({
  type: "POPUP_STATE_UNSET",
  popupName,
})
